import React from "react";
import { AddressDriverNotes } from "./AddressDriverNotes";
import { AddressInput } from "./AddressInput";
import { AddressPointActions } from "./AddressPointActions";
import { AddressPointName } from "./AddressPointName";
import { GoogleMapForAddress } from "./GoogleMapForAddress";

export const CreateOrEditAddressPoint: React.FC<{}> = () => {

    return (
        <div className="address-points-dialog-main-panel">
            <GoogleMapForAddress />
            <AddressInput />
            <AddressPointName />
            <AddressDriverNotes Location={0} />
            <AddressDriverNotes Location={1} />
            <AddressPointActions />
        </div>
        );
}